export const BIKE_STATUS = {
  NORMAL: 'normal',
  WAITING: 'waiting',
  REPAIRING: 'repairing',
  MAINTENANCE: 'maintenance',
  MALFUNCTION: 'malfunction'
}

export const SITE_STATUS = {
  0: 'suspend',
  1: 'inService'
}

export const ZOOM = { POINT: 15, DISTRICT: 14, CITY: 12, COUNTRY: 7 }

export const RENTAL_STATUS = {
  RESERVED: 'reserved',
  SERVICING: 'servicing',
  AVAILABLE: 'available',
  RETUREND: 'returned',
  MALFUNCTION: 'malfunction'
}

export const POWER_STATUS = {
  FUNCTIONAL: 'functional'
}
